'use client';

import { FC, PropsWithChildren, useMemo, useState } from 'react';

import { BottomContainerContext } from '../context/bottom-container-context';

export const BottomContainerProvider: FC<PropsWithChildren> = ({ children }) => {
   const [hasBottomSheet, setHasBottomSheet] = useState(false);

   const contextValue = useMemo(() => ({ hasBottomSheet, setHasBottomSheet }), [hasBottomSheet, setHasBottomSheet]);

   return <BottomContainerContext value={contextValue}>{children}</BottomContainerContext>;
};
